import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { buildMenuBreadcrumb } from '../utils/menuConfig';

/**
 * Interface para item de breadcrumb.
 */
export interface BreadcrumbItem {
  title: string;
  path?: string;
}

/**
 * Hook para gerar breadcrumbs baseado na hierarquia do menu lateral.
 */
export const useBreadcrumbs = (): BreadcrumbItem[] => {
  const location = useLocation();

  return useMemo(
    () => buildMenuBreadcrumb(location.pathname),
    [location.pathname],
  );
};
